import React from 'react'

const PaperClipIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={18}
      viewBox="0 0 16 18"
      fill="none"
      {...props}
    >
      <path
        fill="#999DA8"
        d="M13.266 9.117c.234-.226.601-.258.828-.015.234.21.234.625.008.851L8.32 15.734c-1.93 1.922-4.687 1.774-6.43.04-1.742-1.743-1.89-4.5.04-6.43L9.805 1.46C11.265 0 13.219.094 14.46 1.336c1.273 1.273 1.336 3.195-.125 4.656L6.648 13.68c-.804.804-1.96.82-2.726.054-.703-.703-.735-1.921.062-2.718l5.368-5.368c.234-.234.578-.25.804-.03.227.226.211.57-.023.812L4.78 11.766c-.383.398-.273.851-.008 1.125.266.265.735.382 1.118-.016l7.656-7.656c.89-.899 1.015-2.211.164-3.078-.86-.852-2.18-.727-3.078.171l-7.836 7.829c-1.492 1.5-1.344 3.492-.055 4.773 1.281 1.297 3.29 1.445 4.781-.055l5.743-5.742Z"
      />
    </svg>
  )
}

export default PaperClipIcon
